export function LoginBrandPanel() {
  return (
    <div className="bg-sidebar-gradient flex flex-col justify-between p-6 sm:p-10 sm:w-2/5 relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-white/5" />
      <div className="absolute -bottom-16 -left-10 w-56 h-56 rounded-full bg-white/5" />
      <div className="absolute top-1/2 -right-8 w-32 h-32 rounded-full bg-white/5" />

      {/* Top — Logo + Name */}
      <div className="relative z-10">
        <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/15 rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
          <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h1 className="text-xl sm:text-2xl font-bold text-white tracking-tight">KSP TRADERS</h1>
        <p className="text-blue-200 text-xs sm:text-sm mt-1 leading-relaxed">
          Stock & Financial<br className="hidden sm:block" /> Management System
        </p>
      </div>

      {/* Bottom — Feature bullets (desktop only) */}
      <div className="relative z-10 hidden sm:block space-y-3">
        {[
          { icon: '📦', label: 'Stock & Inventory' },
          { icon: '💰', label: 'Sales & Credits' },
          { icon: '📊', label: 'EOD Reports' },
        ].map(({ icon, label }) => (
          <div key={label} className="flex items-center gap-3">
            <span className="text-base">{icon}</span>
            <span className="text-blue-100 text-sm font-medium">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
